import { useCallback } from 'react';
import { useAuth } from '~/auth/AuthProvider';
import { useUserLogoutMutation } from '~/queries/user/useUserQuery';
import { useIsSSO } from './useIsSSO';
import { useSessionStorage } from './useStorage';

type LogoutCallback = () => void;

/**
 * Hook to handle logging out with additional cleanups
 */
export const useLogout = (): LogoutCallback => {
  const { logout } = useAuth();
  const { isSSO } = useIsSSO();
  const { removeStorageValue: removeUserLoginInit } = useSessionStorage<undefined | number>({
    key: 'USER_LOGIN_INIT',
    initialValue: undefined,
  });

  const { mutateAsync: notifyExplicitLogout } = useUserLogoutMutation();

  const onLogout = useCallback(async () => {
    window.localStorage.removeItem('currentOrganizationShortName');
    window.localStorage.removeItem('currentWorkspaceShortName');

    await notifyExplicitLogout().then(removeUserLoginInit);
    logout({ returnTo: `${window.location.origin}/signout-callback` });
  }, [logout, isSSO]);

  return onLogout;
};
